import React from 'react'
import {Grid, Button, TextField, Typography, Link, Box } from '@mui/material';
import {selectTopUpData, setCardOnFilePaymentValue, setShouldDisplayOtpPrompt} from '../../../../features/userInfo/topUpSlice'
import colors from '../../../colors';
import { useSelector, useDispatch } from 'react-redux';
import { useFormik } from 'formik'
import * as yup from 'yup'
import CardList from './CardList'
import { sendGeneralRequest } from '../../../../features/generalRequest'
import { texts } from '../../../general/texts';
import {renderComponentBasedOnState} from './CardOnFileStates'
import {determineState} from './DetermineState'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { ReactComponent as TopUpCardOptionLogo } from '../../../../icons/TopUpCardOptionLogo.svg';
import { useNavigate } from 'react-router-dom';
import { selectGlobalDataState } from '../../../../features/global/globalDataSlice';
import { setTransId } from '../../../../features/utilities/utilitySlice';

const MakePayment = (props) => 
{
    const topUpDataSliceState = useSelector(selectTopUpData)
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const validationSchema = yup.object({
        value: yup
            .string(texts["message-invalid-topup-value"])
            .matches( /^\d+$/, {
                message: texts["message-invalid-topup-value"],
            })
            .required(texts["message-invalid-topup-value"]),
      });      
    const formik = useFormik({
        initialValues: {
            token: globalDataSliceState.token,
            value: ''
        },
        validationSchema: validationSchema,
        onSubmit: (values) =>
         {
            if(topUpDataSliceState.selectedCard === '')
            {
                dispatch(
                    sendGeneralRequest({
                        request: {token: values.token, paymentMethod: "2", saveCard: false, value: values.value, applicationID: 1},
                        baseUrlKey: "services",
                        endpoint: "CreditBalance",
                      })
                )
                dispatch(setCardOnFilePaymentValue(values.value))
            }
            else
            {
                dispatch(sendGeneralRequest({request: {token: values.token, value: values.value}, baseUrlKey:'services', endpoint:'StartCardsOnFile'})).then((response) => {
                    if (response.payload.response.success){
                        dispatch(setTransId(response.payload.response.transID))
                        dispatch(setShouldDisplayOtpPrompt(true))
                    }
                }) 
                dispatch(setCardOnFilePaymentValue(values.value))
            }
         } 
    })

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            formik.handleSubmit()
        }
    }

    return(
        <Grid container item md={12} xs={12} justifyContent={'center'} columnSpacing={2} padding={3} rowGap={3}>
            <Grid container item md={12} xs={12} mt={2} justifyContent={'left'}><Link component={'button'} onClick={()=> { navigate(-1)}}><ArrowBackIosNewIcon color='warning' /></Link></Grid>
            <Grid container item md={12} xs={12} justifyContent={'left'}  >
                <Grid container justifyContent={'center'} alignItems={'center'} sx={{width:'65px', height:'65px', borderRadius:'20px', background:colors.veryLightOrange, paddingLeft:0.8}} ><TopUpCardOptionLogo  /></Grid>
                <Typography marginTop={1.5} marginLeft={2} sx={{color:colors.darkBlue, fontSize:'1.5rem', fontFamily:'GerberaBold'}} >{texts["title-topup-card"]}</Typography>
            </Grid>
            <Grid container item md={12} xs={12} justifyContent={'left'}   >
                <Typography sx={{color:colors.darkBlue, fontSize:'1.2rem', fontFamily:'GerberaBold'}}>{texts['title-field-amount']}</Typography>
            </Grid>
            <Grid container item md={12} xs={12} justifyContent={'center'}  >
                <TextField id="value" name="value" onChange={formik.handleChange} value={formik.values.value} onKeyDown={handleKeyDown} error={formik.touched.value && Boolean(formik.errors.value)} helperText={formik.touched.value && formik.errors.value} sx={{width:"100%"}} label={texts["placeholder-amount"]} color='warning' size='small'/>
            </Grid>
            <Grid container item md={12} xs={12} justifyContent={'center'} marginTop={20} pb={2}>
                <Button onClick={formik.handleSubmit} id='savedCardButton' sx={{textAlign:'center', width:'100%',  fontFamily:'GerberaMedium', textTransform:'none', background:colors.gradientOrange, color:colors.white}} >{texts["button-top-up-card"]}</Button>
            </Grid>
            <Box sx={{width:'100%', background:colors.cyan, marginLeft:2, padding:2, borderRadius:'20px'}}>
                <Typography sx={{color:colors.darkBlue,  fontFamily:'GerberaLight', textAlign:"start"}}>
                    {topUpDataSliceState.cardOnFileExplanationText}
                </Typography>
            </Box>
        </Grid>
    )
}

export default MakePayment